import styled from 'styled-components';
import BlankModal from '../../common/blank-modal';
import { media } from '../../../styles';
import AwardedAcademyCertification from './awarded-academy-certification';

const DEFAULT_MODAL_STYLE = `
  .modal-dialog {
    width: 90%;
    width: 900px;
    max-width: 900px;

    @media print {
      @page {
        size: landscape;
      }

      width: 100%;
      max-width: initial;
      height: 100%;
    }
  }

  ${media.mobile} {
    // Forces mobile devices to use a scrollable desktop view of the cert
    overflow-x: auto !important;
    .modal-dialog {
      width: 900px;
    }
  }
`;

export default function AwardedAcademyCertificationModal(props) {
  const { academyCertificationUser, isAdminPreview, onClose, customCertificationOptions, academyId } = props;
  if (!academyCertificationUser) return null;

  const certProps = { onClose };
  if (isAdminPreview) {
    certProps.mockCertUserObject = academyCertificationUser;
  } else {
    certProps.academyCertificationUserId = academyCertificationUser.id;
  }

  return (
    <BlankModal
      show={props.show}
      onClose={props.onClose}
      onSave={props.onClose}
      modalStyle={props.modalStyle || DEFAULT_MODAL_STYLE}
    >
      <CloseButtonWrapper onClick={props.onClose} role="button" tabIndex={0}>
        <img src="/images/cross_icon_black.svg" width="12px" height="12px" alt="Close modal" />
      </CloseButtonWrapper>
      <AwardedAcademyCertification
        {...certProps}
        academyNameInAwardedCertTitle={props.academyNameInAwardedCertTitle}
        academyTitle={props.academyTitle}
        academyId={academyId}
        linkedinOrganizationId={props.linkedinOrganizationId}
        themeOptions={props.themeOptions}
        customCertificationOptions={customCertificationOptions}
        inModal
        isVisible={props.show}
      />
    </BlankModal>
  );
}

const CloseButtonWrapper = styled.div`
  position: absolute;
  right: 20px;
  top: 40px;
  cursor: pointer;
  z-index: 2;

  @media print {
    display: none;
  }
`;
